export const ZONES = [
  'Tunis Centre',
  'La Marsa',
  'Ariana',
  'Manouba',
  'Ben Arous',
  'Carthage',
  'Gammarth',
  'Lac 1',
  'Lac 2',
  'Menzah',
  'Ennasr',
]

export const DEPOT_ZONES = ['Zone A', 'Zone B', 'Zone C', 'Zone D']
